/* eslint-disable no-unused-vars */
import { useId } from 'react';
import * as S from './AudienceManagement.styled';
import { Buttons, Message, ErrorComponent, Loader } from 'components';
import { useFacade } from './useFacade';
import { TableHeader } from './components/TableHeader';
import { TableItem } from './components/TableItem';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { ThirdPartyAudience } from './components/thirdPartyAudienceSection/ThirdPartyAudience';

const addFieldsForSorting = (arr) => {
  if (!arr) return null;
  const newArr = arr.map((item) => {
    const campaigns = !item.associated_campaigns ? 0 : item.associated_campaigns.length;
    const new_associated_apps = Object.values(item.associated_apps).map((app) => ({
      ...app,
      image_url: app.icon,
      package: app.package_name,
      pba_number: +app.pba_number,
    }));
    return {
      ...item,
      devices_count: item.custom_audience_file_upload_el.devices_count,
      campaigns,
      associated_apps_count: Object.keys(item.associated_apps).length,
      associated_apps: new_associated_apps,
    };
  });
  return newArr;
};

export const AudienceManagement = () => {
  const { data, isLoading, isError } =
    saveCampaignServiceAPI.useGetCustomAudiencesForManagementQuery();

  const { items, requestSort, getClassNamesFor, redirectAction } = useFacade(
    addFieldsForSorting(data?.custom_audiences),
  );

  const btnId = useId();

  if (isError) {
    return <ErrorComponent />;
  }
  if (isLoading || !data) {
    return (
      <div style={{ width: '100%', height: '200px', display: 'flex', alignItems: 'center' }}>
        <Loader.Local delay={0} />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <S.Field>
        <S.Header>Audience Management</S.Header>
        {items.length > 0 && !isLoading ? (
          <>
            <TableHeader requestSort={requestSort} getClassNamesFor={getClassNamesFor} />
            <S.MyVirtuoso
              style={{
                height: `${items.length * 40 + 2}px`,
                maxHeight: '282px',
              }}
              data={items}
              itemContent={(index, itemData) => (
                <>
                  <TableItem
                    {...itemData}
                    key={itemData.cust_aud_number}
                    isLastElement={index === items.length - 1}
                  />
                </>
              )}
            />
          </>
        ) : (
          <Message type={Message.messageType.information} isOpen={true}>
            There are no custom audiences.
          </Message>
        )}
      </S.Field>
      <ThirdPartyAudience />
      <Buttons.SecondaryNormal
        id={btnId}
        name={btnId}
        onClick={redirectAction}
        style={{ margin: '24px 0 64px 0' }}
      >
        Back to Manage Campaigns
      </Buttons.SecondaryNormal>
    </div>
  );
};
